"use strict";require('@ebay/skin/video');